import { type IconProps } from './Icon.types';

const HamburgerIcon: React.FC<IconProps> = ({
  className,
  fill = 'currentColor',
  width,
}) => {
  const height = width * 0.97;

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 37 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="27.0028"
        y1="13"
        x2="9.00281"
        y2="13"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="27.0028"
        y1="19"
        x2="9.00281"
        y2="19"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="27.0028"
        y1="25"
        x2="9.00281"
        y2="25"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default HamburgerIcon;
